import { useState, useEffect } from "react";

import CollapseControl from "../../../../components/CollapseControl";
import CollapseHeader from "../../../../components/CollapseHeader";
import TableStd from "../../../../components/TableStd";

import ApiService from "../../../../services/apiService";

import ImgNewBlink from "../../../../assets/images/new_blink.gif";
import { PogsignType } from "../../type/Pogsign"
import secureLocalStorage from "react-secure-storage";
import auth from '../../../../utils/authConstants';


const BoxPlano = () => {
  const [isNewPogsCollapsed, setIsNewPogsCollapsed] = useState(false);
  const [isNewInsCollapsed, setIsNewInsCollapsed] = useState(false);
  const [hasNewPogs, setHasNewPogs] = useState(false);
  const [isNewInstruct, setIsNewInstruct] = useState(true);
  const [allNewPogs, setAllNewPogs] = useState<PogsignType[]>([]);
  const [instructPogs, setInstructPogs] = useState<PogsignType[]>([]);

  function uniqueData(data) {
    return data.reduce((acc, current) => {
      const existing = acc.find(item => item.id === current.id);
      if (!existing) {
        acc.push(current);
      }
      return acc;
    }, []);
  }

  useEffect(() => {
    new ApiService(secureLocalStorage.getItem("access_token"))
      .getNewPlanograms()
      .then((res: any) => {
        // Filter instructions
        const instructions = uniqueData(res.filter(pogsign => pogsign.category === "INSTRUCT"));
        setInstructPogs(instructions);

        // Combine all planograms (ALL, INLINE, OFFSHELF) except instructions
        const allPlanograms = uniqueData(
          res.filter(pogsign =>
            ["ALL", "INLINE", "OFFSHELF"].includes(pogsign.pogType) &&
            pogsign.category !== "INSTRUCT"
          )
        );
        setAllNewPogs(allPlanograms);

        // Check if there are any new items
        const newInstruct = instructions.some(pogsign => pogsign.newFlag === true);
        const newPogs = allPlanograms.some(pogsign => pogsign.newFlag === true);

        setIsNewInstruct(newInstruct);
        setHasNewPogs(newPogs);
        setIsNewPogsCollapsed(!newPogs);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const oepnAllCollapse = () => {
    setIsNewPogsCollapsed(false);
    setIsNewInsCollapsed(false);
  };

  const closeAllCollapse = () => {
    setIsNewPogsCollapsed(true);
    setIsNewInsCollapsed(true);
  };

  return (
    <>
      <CollapseControl
        title="IMPORTANT:"
        desc="Printing these POGs in DOC does not replace
            printing POGs from SMS! You MUST print from SMS to clear highlight
            from SMS menu."
        openCollapse={oepnAllCollapse}
        closeCollapse={closeAllCollapse}
      />

      <CollapseHeader
        title="New Planograms"
        isCollapse={isNewPogsCollapsed}
        openCollapse={() => setIsNewPogsCollapsed(false)}
        closeCollapse={() => setIsNewPogsCollapsed(true)}
      >
        <TableStd
          fixedLayout={true}
          titles={[
            { title: "POG ID", align: "left", width: 150 },
            { title: "POG Description & Link", align: "center", width: 400 },
            { title: "Arrival Date", align: "center", width: 150 },
            { title: "Date to be Completed", align: "center", width: 150 },
          ]}
        >
          {hasNewPogs === false ? (
            <tr>
              <td colSpan={4} height={50} align="center">
                <b>There are NO new Planograms at this time.</b>
              </td>
            </tr>
          ) : (
            allNewPogs.map((pogsign, idx) => (
              pogsign.newFlag === true && (
                <tr className={`text-sm ${pogsign.newFlag ? 'bg-[#FEE]' : ''}`} key={idx}>
                  <td className="border-b border-b-[#CCC] px-3 py-[2px]" style={{ width: '150px' }}>
                    <div className="flex items-center gap-2">
                      {pogsign.newFlag && <img src={ImgNewBlink} alt="" />}
                      <span>{pogsign.link?.split('/').pop()?.replace('.pdf', '').toUpperCase()}</span>
                    </div>
                  </td>
                  <td align="center" className="border-b border-b-[#CCC] px-3 py-[2px]" style={{ width: '400px' }}>
                    <button
                      onClick={() => {
                        const token = secureLocalStorage.getItem("access_token");
                        const url = `${auth.REACT_APP_SERVER_API_URL}/get-storage-file?fileName=${pogsign.link}`;

                        fetch(url, {
                          method: 'GET',
                          headers: {
                            'Authorization': `Bearer ${token}`,
                          },
                        })
                          .then(response => {
                            if (!response.ok) {
                              throw new Error('Network response was not ok');
                            }
                            return response.blob();
                          })
                          .then(blob => {
                            const blobUrl = URL.createObjectURL(blob);
                            window.open(blobUrl, '_blank');
                          })
                          .catch(error => console.error('There was a problem with the fetch operation:', error));
                      }}
                      title="You MUST print this POG from SMS to clear highlight from SMS menu screen."
                      className="text-[#06C] no-underline cursor-pointer"
                    >
                      {pogsign.description}
                    </button>
                  </td>
                  <td align="center" className="border-b border-b-[#CCC] px-3 py-[2px]" style={{ width: '150px' }}>
                    {pogsign.arrivalDate}
                  </td>
                  <td align="center" className="border-b border-b-[#CCC] px-3 py-[2px]" style={{ width: '150px' }}>
                    {pogsign.completionDate}
                  </td>
                </tr>
              )
            ))
          )}
        </TableStd>
      </CollapseHeader>

      <CollapseHeader
        title="New Instructions & Documents"
        isCollapse={isNewInsCollapsed}
        openCollapse={() => setIsNewInsCollapsed(false)}
        closeCollapse={() => setIsNewInsCollapsed(true)}
      >
        <TableStd
          titles={[
            { title: "File ID", align: "left", width: 125 },
            { title: "Description & Link", align: "left" },
            { title: "Arrival Date", width: 125 },
          ]}
        >
        { isNewInstruct === false ? (
          <tr>
            <td colSpan={4} height={50} align="center">
              <b>There are NO new Instructions &amp; Documents at this time.</b>
            </td>
          </tr>
        ) : (
          instructPogs.map((pogsign, idx) => (
            pogsign.newFlag === true && (
              <tr className={`text-sm ${pogsign.newFlag ? 'bg-[#FEE]' : ''}`} key={idx}>
                <td className="border-b border-b-[#CCC] px-1 py-[2px]">
                  <div className="flex items-center gap-2">
                    {pogsign.newFlag && <img src={ImgNewBlink} alt="" />}
                    {pogsign.link?.split('/').pop()?.replace('.pdf', '').toUpperCase()}
                  </div>
                </td>
                <td className="border-b border-b-[#CCC] px-1 py-[2px]">
                  <button
                    onClick={() => {
                      const token = secureLocalStorage.getItem("access_token");
                      const url = `${auth.REACT_APP_SERVER_API_URL}/get-storage-file?fileName=${pogsign.link}`;
                      fetch(url, {
                        method: 'GET',
                        headers: {
                          'Authorization': `Bearer ${token}`,
                        },
                      })
                        .then(response => {
                          if (!response.ok) {
                            throw new Error('Network response was not ok');
                          }
                          return response.blob();
                        })
                        .then(blob => {
                          const blobUrl = URL.createObjectURL(blob);
                          window.open(blobUrl, '_blank');
                        })
                        .catch(error => console.error('There was a problem with the fetch operation:', error));
                    }}
                    title="You MUST print this POG from SMS to clear highlight from SMS menu screen."
                    className="text-[#06C] no-underline cursor-pointer"
                  >
                    {pogsign.description}
                  </button>
                </td>
                <td align="center" className="border-b border-b-[#CCC] px-1 py-[2px]">
                  {pogsign.arrivalDate}
                </td>
              </tr>
            )
          ))
         )}
        </TableStd>
      </CollapseHeader>
    </>
  );
};

export default BoxPlano;
